module.exports = __webpack_public_path__ + "static/img/3.e8e7416.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-mercancias-especifico/3.png
// module id = gy5f
// module chunks = 0